import { render, staticRenderFns } from "./ModalManageGroups.vue?vue&type=template&id=0bc8dbb7"
import script from "./ModalManageGroups.vue?vue&type=script&lang=js"
export * from "./ModalManageGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports